/*eslint-disable */
import root from '../_helpers/roots';
import axios from 'axios';
import Vue from 'vue'
let annurl = root.annUrl.link;
let knnurl = root.knnUrl.link;
let knnssmurl  = root.knnPsmUrl.link;
let svmurl = root.svmUrl.link;
let nburl  = root.nbUrl.link;
let RandomForestUrl  = root.randomForestUrl.link;
let DecisionTreeUrl  = root.decisionTreeUrl.link;
let datawellurl  = root.dataWellUrl.link;
let InputAttributesListUrl =  root.inputAttributesListUrl.link;
let knnPsmWeightUrl = root.knnPsmWeightUrl.link
let BrainTumourUrl = root.brainTumourUrl.link;
export default {
  state: {
    dataWellState:{},
    getInputAttrListState:{}
  },
  mutations: {
    getDataWellM(state, value) {
      Vue.set(state, 'dataWellState', value);
    },
    getInputAttrListM(state, value) {
        Vue.set(state, 'getInputAttrListState', value);
      }
  },
  actions: {
    // Create Ann Details
    createAnnDataFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.post(annurl, payload).then(res => {
                resolve(res);
            }).catch(err => {
                reject(err);
            })
        })
    },
    // Create Knn Details
    createKnnDataFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.post(knnurl, payload).then(res => {
                resolve(res);
            }).catch(err => {
                reject(err);
            })
        })
    },
    // Create Knn Psm Details
    createKnnPsmDataFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.post(knnssmurl, payload).then(res => {
                resolve(res);
            }).catch(err => {
                reject(err);
            })
        })
    },
    // Create SVM Details
    createSvmDataFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.post(svmurl, payload).then(res => {
                resolve(res);
            }).catch(err => {
                reject(err);
            })
        })
    },
    // Create SVM Details
    createNbDataFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.post(nburl, payload).then(res => {
                resolve(res);
            }).catch(err => {
                reject(err);
            })
        })
    },
    // Create Brain Tumour Task
    createBrainTumourDataFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.post(BrainTumourUrl, payload).then(res => {
                resolve(res);
            }).catch(err => {
                reject(err);
            })
        })
    },
    // Create Random Forest Details
    createRandomForestDataFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.post(RandomForestUrl, payload).then(res => {
                resolve(res);
            }).catch(err => {
                reject(err);
            })
        })
    },
    // Create Decision Tree Details
    createDecisionTreeDataFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.post(DecisionTreeUrl, payload).then(res => {
                resolve(res);
            }).catch(err => {
                reject(err);
            })
        })
    },
    // Create Knn Psm Weighted Create
    createKnnPsmWeightedDataFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.post(knnPsmWeightUrl, payload).then(res => {
                resolve(res);
            }).catch(err => {
                reject(err);
            })
        })
    },
    // Get Data Well Task Details
    getDataWellFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(datawellurl, payload).then(res => {
              context.commit('getDataWellM', res.data);
              resolve(res);
            }).catch(err => {
                reject(err);
            })
        })
    },
    // Get Input Attributes List
    getInputAttrListFun(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(InputAttributesListUrl + "?task_number=" + payload.id).then(res => {
              context.commit('getInputAttrListM', res.data);
              resolve(res);
            }).catch(err => {
                reject(err);
            })
        })
    }
  },
  getters: {
    dataWellStateGetters: state => state.dataWellState,
    getInputAttrListGetters : state => state.getInputAttrListState
  }
}